import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { useShouldShowScrollToTop } from "./useShouldShowScrollToTop";

import "./ScrollToTop.scss";

const ScrollToTop = () => {
  const shouldShowTopButton = useShouldShowScrollToTop();

  const executeScroll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const { __ } = useTranslations();

  return shouldShowTopButton ? (
    <button onClick={executeScroll} className={`scroll-to-button`} aria-label={__("loyalty.scroll_to_top.label")}>
      <ChevronUpIcon className={`icon`} aria-hidden="true" />
    </button>
  ) : null;
};

export default ScrollToTop;
